/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import StyledTableBody from './TableBody.styles';
import type { FilterType } from '../../types/filterTypes';
import type { OrderType } from '../../types/orderTypes';
import TableBodyRow from '../TableBodyRow/TableBodyRow';
import { useAppSelector } from '../../store/hooks';
import TableBodyRowOrderAdmin from '../TableBodyRowOrderAdmin';
import TableBodyRowUserAdmin from '../TableBodyRowUserAdmin';
import TableBodyRowCodeAdmin from '../TableBodyRowCodeAdmin';
import type { AdminPaymentType, PaymentType, UserType } from '../../types/userTypes';
import type { CodeType } from '../../types/codeTypes';
import { useLocationName, usePathIncludeLocation } from '../../utils/checkLocationHelper';
import TableBodyRowPayment from '../TableBodyRowPayment/TableBodyRowPayment';
import type { CouponType } from '../../types/couponTypes';
import TableBodyRowCouponAdmin from '../TableBodyRowCouponAdmin';
import TableBodyRowPaymentAdmin from '../TableBodyRowPaymentAdmin/TableBodyRowPaymentAdmin';
import ErrorBalanceModal from '../ErrorBalanceModal/ErrorBalanceModal';
import Bill from '../Bill/Bill';
import OrderTransactionsModal from '../OrderTransactionsModal';

type PropsType = {
  filter: FilterType;
  setFilter: (title: string, value: string | Date | null) => void;
  mainArray: Array<OrderType | UserType | PaymentType | CodeType | CouponType>;
  length: number;
};

const TableBody: React.FC<PropsType> = (props) => {
  const isAdminUser = useAppSelector((state) => state.userSlice.user.isSuperUser);
  const user = useAppSelector((state) => state.userSlice.user);
  const locationName = useLocationName();
  const isOrderPage = locationName === 'orders';
  const isCodesPage = locationName === 'codes';
  const isPaymentsPage = locationName === 'payments';
  const isCouponPage = locationName === 'coupons';
  const adminPaymentsPage = locationName === 'all-payments';
  const isUsedDashboardPage = usePathIncludeLocation('/dashboard');
  const [isOpenErrorBalanceModal, setIsOpenErrorBalanceModal] = useState(false);
  const [isOpenBillModal, setIsOpenBillModal] = useState(false);
  const [selectedOrderForTransactions, setSelectedOrderForTransactions] = useState<
  OrderType | null>(null);
  const navigate = useNavigate();

  const onCurrentClickBalanceModal = () => {
    navigate('/payments/enter-amount');
  };

  const onClickCancelBalanceModal = () => {
    setIsOpenErrorBalanceModal(false);
  };

  const handleCloseBillModal = () => {
    setIsOpenBillModal(false);
  };

  return (
    <>
      <StyledTableBody>
      {props.mainArray?.length
        ? props.mainArray.map((item, index) => (
          isAdminUser ? (
            isOrderPage || isUsedDashboardPage ? (
              <TableBodyRowOrderAdmin
                key={index}
                item={item as OrderType}
                className="text-2"
                user={user}
                onViewTransactions={setSelectedOrderForTransactions}
              />
            ) : isCodesPage ? (
              <TableBodyRowCodeAdmin key={index} item={item as CodeType} className="text-2" />
            ) : isCouponPage ? (
              <TableBodyRowCouponAdmin key={index} item={{ index: index + 1, ...item } as CouponType} className="text-2" />
            ) : adminPaymentsPage ? (
              <TableBodyRowPaymentAdmin key={index} item={item as AdminPaymentType} className="text-2" />
            ) : (
              <TableBodyRowUserAdmin key={index} item={item as UserType} className="text-2" />
            )
          ) : (
            isPaymentsPage ? (
              <TableBodyRowPayment key={index} item={item as PaymentType} className="text-2" />
            ) : (
              <TableBodyRow key={index} item={item as OrderType} className="text-2" setIsOpenBillModal={setIsOpenBillModal} setIsOpenErrorBalanceModal={setIsOpenErrorBalanceModal} />
            )
          )
        )) : (
          <tr>
            <td colSpan={props.length} className="styled-table-body__one-column-td">
              <div className="styled-table-body__one-column-td__no-data-info text-4">No data available in table</div>
            </td>
          </tr>
        )
      }
      </StyledTableBody>
    {
      !isAdminUser || !isPaymentsPage ? (
        <>
        {isOpenErrorBalanceModal ? (
        <ErrorBalanceModal
          onCloseModal={onClickCancelBalanceModal}
          onClick={onCurrentClickBalanceModal}
        />
        ) : null}
        {isOpenBillModal ? (
        <Bill
          open={isOpenBillModal}
          onClose={handleCloseBillModal}
        />
        ) : null}
        </>
      ) : null}
      {selectedOrderForTransactions ? (
        <OrderTransactionsModal
          order={selectedOrderForTransactions}
          onCloseModal={() => setSelectedOrderForTransactions(null)}
        />
      ) : null}
    </>
  );
};

export default TableBody;
